import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../theme";

interface Props {
  title: React.ReactNode;
  defaultExpanded?: boolean;
  testId?: string;
  children: React.ReactNode;
}

export default function CollapsiblePanel({
  title,
  defaultExpanded = true,
  testId,
  children,
}: Props) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      data-testid={testId}
      sx={{
        boxShadow: tokens.shadowCard,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        "&:before": { display: "none" },
        "&.Mui-expanded": { margin: 0 },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          minHeight: 48,
          "& .MuiAccordionSummary-content": { my: 1 },
        }}
        data-testid={testId ? `${testId}-summary` : undefined}
      >
        {typeof title === "string" ? (
          <Typography variant="h6" sx={{ fontSize: "1.05rem" }}>
            {title}
          </Typography>
        ) : (
          title
        )}
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 2 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
